const PUBLIC_SIGNING_PATH_PREFIXES = ['/pdf-sign/', '/sign/', '/s/'] as const;

export const isPublicSigningPath = (pathname: string) =>
  PUBLIC_SIGNING_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  );
